import React from "react";
import {IS_CORDOVA} from "../envs/_current/config";

const Ahref = ({
                   href = "#",
                   children,
                   onClick,
                   ...props
               }) => {

    const handleClick = (e) => {
        if (!href) return;

        if (IS_CORDOVA) {
            // ✅ Link ngoài: https, mailto, tel, intent, geo, sms...
            if (/^(https?:|mailto:|tel:|intent:|geo:|sms:)/i.test(href)) {
                try {
                    e.preventDefault();
                } catch (e) {
                }
                try {
                    e.stopPropagation();
                } catch (e) {
                }
                try {
                    e.stopImmediatePropagation();
                } catch (e) {
                }


                if (window?.cordova?.InAppBrowser) {
                    window.cordova.InAppBrowser.open(
                        href,
                        "_system", // mở Chrome ngoài app
                        "location=yes"
                    );
                } else {
                    window.open(href, "_blank", "noopener,noreferrer");
                }
                return;
            }

            // ✅ Link nội bộ (/, ./, #, file:)
            if (
                href.startsWith("/") ||
                href.startsWith(".") ||
                href.startsWith("#") ||
                href.startsWith("file:")
            ) {
                return; // để router / app xử lý
            }

            // Nếu không khớp pattern nào, cũng chặn mặc định
            e.preventDefault();
        } else {
            onClick(e)
        }
    };

    return (
        <a
            href={href}
            onClick={handleClick}
            {...props}
        >
            {children}
        </a>
    );
}

export default Ahref